var platinum = "/static/5539f0f1ebd8eb24.png";

export { platinum as default };
//# sourceMappingURL=platinum.png.js.map
